// extracted by mini-css-extract-plugin
export default {"saveButton":"Save_saveButton__DUQvK","saveButtonSaved":"Save_saveButtonSaved__Kd36O"};